import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

import type {
  CommunicationSelfTestPreview,
  CommunicationSelfTestRequest,
  CommunicationSelfTestResult,
} from "@/types/adminV2/communicationSelfTest";

export const buildAdminV2CommunicationSelfTestEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  previewAdminV2CommunicationSelfTest: builder.mutation<
    { preview: CommunicationSelfTestPreview },
    CommunicationSelfTestRequest
  >({
    query: (data) => ({
      url: "/admin/v2/messaging/messages/test-send/preview",
      method: "POST",
      data,
    }),
  }),
  sendAdminV2CommunicationSelfTest: builder.mutation<
    CommunicationSelfTestResult,
    CommunicationSelfTestRequest & {
      confirmedDigest: string;
      requestKey: string;
    }
  >({
    query: (data) => ({
      url: "/admin/v2/messaging/messages/test-send",
      method: "POST",
      data,
    }),
    invalidatesTags: [{ type: "AdminV2MessagingEmailActivity", id: "LIST" }],
  }),
});
